<app-kpi-widget
  [title]="'fuelConsumption.widgets.totalFuelUsed' | transloco"
  [icon]="icon"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="fuelUsedPercentageChange"
  [widgetDisabled]="widgetDisabled"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isUptrendPositive]="true"
  [dropdownEnabled]="false"
  [hasFooter]="false">
</app-kpi-widget>